
import './init'

// Entry point for styles (webpack)
// Don't worry about these being here, we import them for webpack dev
// In the production build they are removed from bundle.js and output to their own .css
import '../../styles/style.scss'
import 'notyf/notyf.min.css';

import objectFitImages from 'object-fit-images'
import inlineSVG from 'inline-svg'

import DataLayer from './dataLayer'
import Affiliate from './affiliate'
import Navigation from './navigation'
import Tabs from './tabs'
import Accordion from './accordion'
import GoogleCookie from './googleCookie'
import Social from './social'

GoogleCookie.setCookies();

function hasTouch() {
  return (
    'ontouchstart' in document.documentElement ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

if (hasTouch()) {
  document.body.className += ' is-touch'
}

new DataLayer() // Set up DataLayer events on DOM elements (non vue)
new Affiliate() // Set session from window variable (to be then used in vue)
new Navigation() // Setup responsive navigation
new Accordion() // Control Accordion component

document.querySelectorAll('[data-init="tabbed"]').forEach((element) => {
  new Tabs(element); // Control Tabbed components
})

document.querySelectorAll('.component-social-menu .social-link').forEach((el) => {
  new Social(el) // Open new window on social click
})

document.querySelectorAll('tr[data-href]').forEach(row => row.addEventListener('click', () => {
  window.location.href = row.dataset.href;
}))

objectFitImages('.as-background img', { watchMQ: true })

// Fix for hovers
document.addEventListener('touchstart', function () { }, true)

if (module.hot) {
  module.hot.accept()
}

const cxLoyaltykeepAliveIframeUrlHack = sessionStorage.getItem(
  'cxLoyaltykeepAliveIframeUrlHack'
)

if (cxLoyaltykeepAliveIframeUrlHack) {
  const iframe = document.createElement('iframe')
  iframe.src = cxLoyaltykeepAliveIframeUrlHack
  iframe.style.display = 'none'
  iframe.setAttribute('width', 0)
  iframe.setAttribute('height', 0)
  iframe.setAttribute('tabindex', -1)
  document.body.appendChild(iframe)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    onDomContentLoaded();
  });
} else {
  onDomContentLoaded();
}

function onDomContentLoaded() {
  inlineSVG.init({
    svgSelector: 'img.svg',
    initClass: 'js-inlinesvg'
  });
}

